// extracted by mini-css-extract-plugin
module.exports = {"screen":"idt-desktop_screen__-7ben"};